import { api } from "./api";

export type ProductType =
  | "STARTER"
  | "MAIN_COURSE"
  | "DESSERT"
  | "DRINK"
  | "SIDE";

export interface EstimationByType {
  type: ProductType;
  label: string;
  count: number;
}

export interface EstimationByProduct {
  productId: string;
  productName: string;
  type: ProductType;
  typeLabel: string;
  totalQuantity: number;
}

export interface EstimationByProductZone {
  productId: string;
  productName: string;
  type: ProductType;
  typeLabel: string;
  zoneId: string;
  zoneName: string;
  zoneNumber: number | null;
  totalQuantity: number;
}

export interface EstimationByIngredient {
  ingredientId: string;
  ingredientName: string;
  unit: string | null;
  totalQuantity: number;
}

export interface EstimatedByType {
  type: ProductType;
  label: string;
  estimated: number;
}

export interface EstimatedByProduct {
  productId: string;
  productName: string;
  type: ProductType;
  typeLabel: string;
  estimated: number;
}

export interface EstimationsResult {
  dateFrom: string;
  dateTo: string;
  byType: EstimationByType[];
  byProduct: EstimationByProduct[];
  byProductZone: EstimationByProductZone[];
  byIngredient: EstimationByIngredient[];
  estimatedByType: EstimatedByType[];
  estimatedByProduct: EstimatedByProduct[];
}

function emptyEstimationsResult(dateFrom: string, dateTo: string): EstimationsResult {
  return {
    dateFrom,
    dateTo,
    byType: [],
    byProduct: [],
    byProductZone: [],
    byIngredient: [],
    estimatedByType: [],
    estimatedByProduct: [],
  };
}

export const estimationService = {
  async getEstimations(dateFrom: string, dateTo: string): Promise<EstimationsResult> {
    const response = await api.get<{ success: boolean; data?: EstimationsResult }>(
      '/estimations',
      { params: { dateFrom, dateTo } }
    );
    return response.data?.data ?? emptyEstimationsResult(dateFrom, dateTo);
  },

  /**
   * Met à jour l'estimation (surcharge) pour un produit sur la période. Enregistrement immédiat.
   */
  async updateProductEstimation(
    dateFrom: string,
    dateTo: string,
    productId: string,
    estimated: number
  ): Promise<EstimatedByProduct> {
    const response = await api.patch<{ success: boolean; data: EstimatedByProduct }>(
      `/estimations/products/${productId}`,
      { estimated },
      { params: { dateFrom, dateTo } }
    );
    return response.data.data;
  },
};
